<template>
    <transition name="tips-downIn">
        <section class="top-tips" v-show="showTips">
            <div class="tips-inner">
                <div class="tips-left">
                    <i class="fa fa-exclamation-circle"></i> 提示
                </div>
                <div class="tips-middle">
                    <p>{{ msg }}</p>
                </div>
                <div class="tips-right" @click="close">
                    <i class="fa fa-remove"></i>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
    let timer = null;
    const MAX_LIVE = 4;

    export default {
        name: "top-tips",
        data() {
            return {
                showTips: false,
                msg: ''
            }
        },
        methods: {
            close() {
                this.showTips = false;
                this.msg = '';
                clearInterval(timer);
                timer = null;
            },
            show(msg) {
                this.msg = msg;
                this.showTips = true;
                // 如果重复触发那么需要重新计时
                if (timer) {
                    clearInterval(timer);
                }
                this.setIntervalClose();
            },
            setIntervalClose() {
                let i = 0;
                timer = setInterval(() => {
                    if (i > MAX_LIVE) {
                        this.showTips = false;
                        clearInterval(timer);
                    }
                    i++;
                }, 1000);
            }
        }
    }
</script>

<style scoped>
    .tips-downIn-enter-active,
    .tips-downIn-leave-active {
        transition: all 0.3s ease;
    }

    .tips-downIn-enter-from,
    .tips-downIn-leave-to {
        transform: translate3d(0%, -100%, 0);
    }

    .top-tips{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background-color: #fff;
        padding: 15px;
        box-shadow: 0 0 5px #ccc;
    }
    .tips-inner{
        display: flex;
        justify-content: space-between;

    }
    .tips-left{
        flex: 0 0 60px;
        color: #EE5B5B;
        font-size: 16px;
        font-weight: 700;
    }
    .tips-left .fa{
        font-size: 18px;
    }
    .tips-middle{
        flex: 1;
        padding: 0 10px;
        font-size: 16px;
        word-break: break-all;
    }
    .tips-right{
        flex: 0 0 30px;
        text-align: center;
        color: #666;
        font-size: 16px;
    }
</style>
